<mat-form-field appearance="outline" class="single-select-input-field" [floatLabel]="'always'">
  <mat-label *ngIf="label">{{ label | translate }}</mat-label>
  <input 
    type="text" 
    [placeholder]="placeholder | translate" 
    matInput 
    [matAutocomplete]="auto"
    [formControl]="control">
  
  <!-- Botón de limpiar -->
  <mat-icon *ngIf="hasControlValue()" matSuffix class="clear-button"  (click)="onClear()" fontSet="material-symbols-outlined">
    ink_eraser_off
  </mat-icon>
  
  <!-- Icono de flecha hacia abajo cuando no hay valor -->
  <mat-icon *ngIf="!hasControlValue()" matSuffix class="dropdown-icon" fontSet="material-icons-outlined">
    keyboard_arrow_down
  </mat-icon>
  
  <mat-autocomplete 
    #auto="matAutocomplete" 
    [displayWith]="displayFn"
    (optionSelected)="onSelect($event.option.value)"
    (opened)="isOpenPanel = false"
    (closed)="isOpenPanel = true">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option" class="select-option">
      <span class="option-text">{{ displayFn(option) }}</span>
      <img *ngIf="isSelected(option)" src="https://munily-public-cdn.s3.us-east-1.amazonaws.com/general/checkGreenCircle2D.png" alt="Selected" class="selected-icon">
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
